import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  fetchAnalytics,
  fetchAnalyticsChart,
  fetchLatestOrders,
  fetchLatestUsers,
} from "../../../store/slices/dashbaordSlice";

import InfoCard from "./infoCard";
import ListCard from "./listCard";
import ChartCard from "./chartCard";
import colors from "../../../share/constants/constants";
import Positive from "../../../assets/icons/dashboard/positive.svg";
import Negative from "../../../assets/icons/dashboard/negative.svg";
import Download from "../../../assets/icons/dashboard/download.svg";
import moment from "moment";
import { Skeleton } from "antd";
import { getiOSDownloads } from "../../../api/analytics";

const Dashboard = () => {
  const dispatch = useDispatch();

  // const [loading, setLoading] = useState(false);
  const [secondRow, setSecondRow] = useState([]);
  const [selectedYear, setSelectedYear] = useState(moment().year());
  const [formattedData, setFormattedData] = useState([]);
  const [latestOrders, setLatestOrders] = useState([]);
  const [latestUsers, setLatestUsers] = useState([]);
  const [downloads, setDownloads] = useState([]);

  const {
    res: analytics,
    chart,
    orders,
    users,
    isLoading,
    isChartLoading,
    isOrderLoading,
    isUsersLoading,
  } = useSelector((state) => state?.dashboard);

  useEffect(() => {
    dispatch(fetchAnalytics());
  }, [downloads]);

  useEffect(() => {
    dispatch(fetchAnalyticsChart(selectedYear));
  }, [selectedYear]);

  useEffect(() => {
    dispatch(fetchLatestOrders({ pageNumber: 1, itemPerPage: 3 }));
  }, []);

  useEffect(() => {
    dispatch(fetchLatestUsers({ pageNumber: 1, itemPerPage: 3 }));
  }, []);

  useEffect(() => {
    let ordersList = [];
    if (orders) {
      ordersList = orders?.map((order) => {
        return {
          avatar: order?.orderNumber,
          name: `${order?.customerName}`,
          orderNo: order?.orderNumber,
        };
      });
      setLatestOrders(ordersList);
    }
  }, [orders]);

  useEffect(() => {
    let usersList = [];
    if (users) {
      usersList = users?.map((user) => {
        return {
          avatar: user?.orderNumber,
          name: `${user?.firstName} ${user?.lastName}`,
          timeStamp: moment(user?.createdAt).fromNow(),
        };
      });
      setLatestUsers(usersList);
    }
  }, [users]);

  useEffect(() => {
    const getIcon = (percentage) => {
      return percentage >= 0 ? Positive : Negative;
    };

    const formatPercentage = (percentage) => {
      const formatted = percentage.toFixed(1);
      return formatted.endsWith(".0") ? formatted.slice(0, -2) : formatted;
    };

    if (analytics) {
      const firstRow = [
        {
          label: "Total Orders",
          info: analytics.totalOrders,
          icon: getIcon(analytics?.orderPercentage),
          color: colors.secondaryOrange,
          text: `${formatPercentage(analytics?.orderPercentage)}% vs last week`,
        },
        {
          label: "Completed Orders",
          info: analytics.completedOrders,
          icon: getIcon(analytics?.completedOrderPercentage),
          color: colors.primaryPurple,
          text: `${formatPercentage(
            analytics?.completedOrderPercentage
          )}% vs last week`,
        },
        {
          label: "Pending Orders",
          info: analytics.pendingOrders,
          color: colors.secondaryOrange,
          textColor: "#F62424",
          text: `${analytics?.newOrders} New Orders`,
        },
        {
          label: "iOS Downloads",
          info: downloads?.iOSDownloadsTotal,
          icon: Download,
          color: colors.primaryPurple,
          text: `${downloads?.iOSDownloadsLastDay} on ${moment(
            downloads?.iOSLastRecordDate
          ).format("MM-DD-yyy")}`,
        },
      ];

      const secondRow = [
        {
          label: "Total Customers",
          info: analytics?.totalCustomers,
          icon: getIcon(analytics?.customersPercentage),
          color: colors.primaryPurple,
          text: `${formatPercentage(
            analytics?.customersPercentage
          )}% vs last week`,
        },
        {
          label: "Gross Revenue",
          info: `$${analytics?.grossRevenue}`,
          icon: Positive,
          color: colors.secondaryOrange,
          text: "10% vs last week",
        },
        {
          label: "Pending Amount",
          info: `$${analytics?.pendingAmounts}`,
          icon: Positive,
          color: colors.primaryPurple,
          text: "10 vs last week",
        },
        {
          label: "Android Downloads",
          info: downloads?.androiddDownloadsTotal,
          icon: Download,
          color: colors.primaryPurple,
          text: `${downloads?.androiddDownloadsLastDay} on ${moment(
            downloads?.androidLastRecordDate
          ).format("MM-DD-yyy")}`,
        },
      ];
      setFormattedData(firstRow);
      setSecondRow(secondRow);
    }
  }, [analytics]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getiOSDownloads();
        setDownloads(res);
      } catch (error) {
      } finally {
      }
    };
    fetchData();
  }, []);
  return (
    <>
      <div className="grid gap-2 space-x-2 w-full pr-2">
        <div className="flex items-center ml-2 mt-2 ">
          <span className="text-lg font-medium text-black ml-1">Dashboard</span>
        </div>
        <div>
          <div className="grid grid-cols-1 gap-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
            {isLoading &&
              Array(8)
                .fill()
                .map(() => (
                  <InfoCard
                    label={"-"}
                    info={
                      <Skeleton.Avatar
                        active={true}
                        size={"small"}
                        shape={"square"}
                      />
                    }
                    icon={""}
                    text={"-"}
                    color={"gray"}
                    textColor={"gray"}
                  />
                ))}
            {!isLoading &&
              formattedData &&
              formattedData.map((rowData, i) => (
                <div key={i}>
                  <InfoCard
                    label={rowData?.label}
                    info={rowData?.info}
                    icon={rowData?.icon}
                    text={rowData?.text}
                    color={rowData?.color}
                    textColor={rowData?.textColor}
                  />
                </div>
              ))}
            {!isLoading &&
              secondRow &&
              secondRow.map((rowData, i) => (
                <div key={i}>
                  <InfoCard
                    label={rowData?.label}
                    info={rowData?.info}
                    icon={rowData?.icon}
                    text={rowData?.text}
                    color={rowData?.color}
                    textColor={rowData?.textColor}
                  />
                </div>
              ))}
          </div>
        </div>
        <div>
          <div className="grid custom-grid gap-2">
            <div className="row-span-2">
              <ChartCard
                info="Revenue"
                chartData={chart}
                selectedYear={selectedYear}
                setSelectedYear={setSelectedYear}
                loading={isChartLoading}
              />
            </div>
            <div>
              <div className="flex flex-col gap-2">
                <ListCard
                  label="Order History"
                  list={latestOrders}
                  loading={isOrderLoading}
                />
                <ListCard
                  label="New Users"
                  list={latestUsers}
                  loading={isUsersLoading}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Dashboard;
